import { surface } from "./foundation";
export const Alert = surface("div", "alert", "cyra-notice");
export const AlertTitle = surface("h3", "alert-title", "font-medium");
export const AlertDescription = surface("div", "alert-description", "text-sm");
